import React, { SyntheticEvent, useMemo } from 'react'
import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { useAppSelector } from '../../../shared/lib/hooks/useAppSelector/useAppSelector'
import {
	selectClientLabels,
	selectLabelNameColorDict
} from '../../../features/DisplayClientLabels'

interface ManagersNamesComboProps {
	clientLabelNames: string[],
	handleClientLabelsChange: (
		e: SyntheticEvent<Element, Event>,
		value: string[]
	) => void,
}

export const LabelsCombo = (props: ManagersNamesComboProps) => {
	const { clientLabelNames, handleClientLabelsChange } = props
	const clientLabels = useAppSelector(selectClientLabels) // imported from features level
	const clientLabelNameColorDict = useAppSelector(selectLabelNameColorDict) // imported from features level

	const clientLabelOptions = useMemo(() => {
		return clientLabels.map(label => label.labelName)
	}, [clientLabels])

	return (
		<Autocomplete
			sx={{ mb: '1rem' }}
			multiple
			id="client-labels-add"
			options={clientLabelOptions}
			value={clientLabelNames}
			onChange={handleClientLabelsChange}
			renderTags={(value: string[], getTagProps) =>
				value.map((option, index: number) => (
					<Chip
						sx={{
							color: '#ffffff',
							// @ts-ignore
							backgroundColor: clientLabelNameColorDict[option] || '#4B6687',
							'& .MuiChip-deleteIcon': {
								color: 'white'
							}
						}}
						variant="filled"
						label={option}
						{...getTagProps({ index })}
					/>
				))
			}
			renderInput={(params) => (
				<TextField
					{...params}
					variant="outlined"
					label="Labels"
				/>
			)}
		/>
	)
}
